import { fromJS } from 'immutable';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { Text } from 'foundations-components/components/Text';
import { AREA } from 'reporting-data/constants/chartTypes';
import { TIME_SERIES } from 'reporting-data/constants/configTypes';
import { ANALYTICS_ALL_PAGES } from 'reporting-data/constants/dataTypes';
import { EQ, IN } from 'reporting-data/constants/operators';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { ALL_METRICS, MAB_VARIATION_COLORS } from '../../constants/reporting';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getReport = ({
  dateRange,
  frequency,
  variantIds
}) => {
  const customColors = variantIds.length <= MAB_VARIATION_COLORS.length ? variantIds.reduce((acc, id, index) => {
    acc[id] = MAB_VARIATION_COLORS[index];
    return acc;
  }, {}) : {};
  return fromJS({
    chartType: AREA,
    config: {
      configType: TIME_SERIES,
      dataType: ANALYTICS_ALL_PAGES,
      dimensions: ['sessionDate', 'breakdown'],
      filters: {
        custom: [{
          operator: IN,
          property: 'filters',
          values: variantIds
        }, {
          operator: EQ,
          property: 'scaleByPercent',
          value: true
        }],
        dateRange: {
          property: 'sessionDate',
          value: dateRange
        }
      },
      frequency,
      metrics: [{
        metricTypes: ALL_METRICS.rawViews.metricTypes,
        property: 'rawViews'
      }]
    },
    displayParams: {
      colors: {
        custom: customColors
      },
      rhumbConfig: {
        renderSuccessMarker: () => /*#__PURE__*/_jsx(NavMarker, {
          name: "MAB_VIEWS_CHART_LOADED"
        })
      },
      seriesOrder: {
        type: 'static',
        values: variantIds
      },
      stacked: true,
      yAxis: {
        bounds: {
          max: 100
        },
        title: {
          enabled: false
        }
      }
    }
  });
};
const MABViewsChart = ({
  dateRange,
  frequency,
  variantIds
}) => {
  const report = getReport({
    variantIds,
    dateRange,
    frequency
  });
  if (!report) {
    return null;
  }
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-test-id": "mab-views-chart",
    compact: true,
    children: [/*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.personalization.mabViewsChart.header"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          marginBlockStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "page-details-ui.testResults.personalization.mabViewsChart.header"
          })
        })]
      }),
      titleSize: "large"
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(PlatformReportResolver, {
        report: report,
        useInlineLabels: false
      })
    })]
  });
};
export default MABViewsChart;